export default "__VITE_ASSET__QvtkqjD2__"